module.exports = __webpack_public_path__ + "img/loca_health_bg.31640163.png";